export const LIST_QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'] as const

export const getListQuarters = (period?: string | null): string[] =>
  LIST_QUARTERS.filter((quarter) =>
    (period?.match(/Q[1-4]/gi) ?? []).some((value) => value.toUpperCase() === quarter)
  )

export const getListPeriodKey = (period?: string | null): string => {
  const quarters = getListQuarters(period)
  if (quarters.length === 4) return 'full-year'
  if (quarters.join(',') === 'Q1,Q2') return 'h1'
  if (quarters.join(',') === 'Q3,Q4') return 'h2'
  return quarters.join(',')
}

export const compareListPeriods = (left?: string | null, right?: string | null) => {
  const leftQuarters = getListQuarters(left),
    rightQuarters = getListQuarters(right)
  return (
    (LIST_QUARTERS.findIndex((quarter) => leftQuarters.includes(quarter)) === -1
      ? 4
      : LIST_QUARTERS.findIndex((quarter) => leftQuarters.includes(quarter))) -
      (LIST_QUARTERS.findIndex((quarter) => rightQuarters.includes(quarter)) === -1
        ? 4
        : LIST_QUARTERS.findIndex((quarter) => rightQuarters.includes(quarter))) ||
    rightQuarters.length - leftQuarters.length ||
    leftQuarters.join(',').localeCompare(rightQuarters.join(','))
  )
}
